<template>
  <NButtonToggleGroup
    v-gid="{
      module: 'symbol',
      screen: 'home',
      section: 'symbolLineChart',
      component: 'symbolLineChartTimeframes',
    }"
    color="gray"
    :model-value="SYMBOL_LINE_CHART_FILTERS[selectedTimespan].value"
    @update:model-value="(value) => emit('changeSelectedTimespan', value)"
  >
    <template v-for="timespan of SYMBOL_LINE_CHART_FILTERS" :key="timespan.id">
      <NButtonToggle
        v-gid="{
          module: 'symbol',
          screen: 'home',
          section: 'symbolDetailChart',
          component: `${timespan.id}TimespanButton`,
        }"
        :label="timespan.label"
        :model-value="timespan.id"
        class="w-max"
        @click="emit('changeSelectedTimespan', timespan.id)"
      />
    </template>
  </NButtonToggleGroup>
</template>

<script setup lang="ts">
import { SYMBOL_LINE_CHART_FILTERS } from '@/modules/symbol';

type FilterListPropsType = {
  selectedTimespan: string;
};
type FilterListEmitsType = {
  (e: 'changeSelectedTimespan', timespan: string): void;
};

defineProps<FilterListPropsType>();
const emit = defineEmits<FilterListEmitsType>();
</script>
